import { useEffect, useRef, useState } from 'react';

export const useGetEqualChartBarValueWidth = ({ isFetching }: { isFetching: boolean }) => {
    const [maxWidth, setMaxWidth] = useState<number>(0);

    const budgetRef = useRef<HTMLDivElement | null>(null);
    const needRef = useRef<HTMLDivElement | null>(null);
    const lastRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        const elements = [budgetRef.current, needRef.current, lastRef.current].filter(
            Boolean
        ) as HTMLDivElement[];

        if (elements.length === 0) return;

        const measure = () => {
            const widths = elements.map((el) => el.offsetWidth);
            const max = Math.max(...widths) + 12; // подгоняю под размеры, поэтому +12
            setMaxWidth((prev) => (prev !== max ? max : prev));
        };

        measure();
        const observer = new ResizeObserver(measure);
        elements.forEach((el) => observer.observe(el));

        return () => observer.disconnect();
    }, [isFetching]);

    return {
        maxWidth,
        budgetRef,
        needRef,
        lastRef,
    };
};
